import { render, staticRenderFns } from "./CompanyRecruit.vue?vue&type=template&id=7ffcafe4&scoped=true"
import script from "./CompanyRecruit.vue?vue&type=script&lang=js"
export * from "./CompanyRecruit.vue?vue&type=script&lang=js"
import style0 from "./CompanyRecruit.vue?vue&type=style&index=0&id=7ffcafe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffcafe4",
  null
  
)

export default component.exports